import { ROLE } from "../enums/QueryKeys";
import { useQuery } from "@tanstack/react-query";
import { fetchRoleByUserId } from "../enums/queryFunction/Fetch";

export function useGetUserRole(userId) {

   const { data, isLoading, error } = useQuery({
     queryKey: [ROLE,userId],
     queryFn: () => fetchRoleByUserId(userId),
     staleTime: Infinity,
   });
 
  return { data, isLoading, error };
}
